import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TranscriptCacheService } from '@go-modules/services/transcript-cache/transcript-cache.service';

export const transcriptCacheServiceModule = angular.module('transcriptCacheServiceModule', [])
	.factory('transcriptCacheService', downgradeInjectable(TranscriptCacheService))
	.name;
